export default __webpack_public_path__ + "static/ticketDownloadEn-8921eed86fab23405e7afe021d2e26f3.png";